module.exports = __webpack_public_path__ + "static/media/DSC_2884.9e2ded17.jpg";